var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flix-capacity"},[_c('flixIcon',{attrs:{"id":"user"}}),_vm._v(" "+_vm._s(_vm.capacity[1])+" / "+_vm._s(_vm.capacity[2])+" ("+_vm._s(_vm.capacity[3])+"%)")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }